import React, { useEffect } from 'react';
import { GroupsSearchResults, SearchInput } from '../index';
import find from 'lodash/find';
import CrossIcon from '../Icons/CrossIcon';

function SearchGroupsModal(props) {
  const { hide, searchGroups, token, searchResults, myGroupsOnly, myGroups } = props;

  useEffect(() => {
    handleSearchPeople('');
  }, []);

  function handleSearchPeople(value) {
    searchGroups(value, token.key);
  }

  const groups =
    myGroupsOnly === false
      ? props.searchResults.groups
      : props.searchResults.groups.filter((group) => {
          if (find(myGroups, { id: group ? group.id : '' })) {
            return true;
          } else {
            return false;
          }
        });

  return (
    <div
      className="find-groups modal-content modal-lg"
      style={{ width: '650px', backgroundColor: 'white' }}
    >
      <div className="modal-header bg-white pb-0 d-flex align-items-center justify-content-between mb-1">
        <h5 className="modal-title-search font-weight-semibold text-center p-0 m-0">
          {myGroupsOnly ? 'My groups' : 'Find groups'}
        </h5>
        <div className="create-group__close" onClick={hide}>
          <CrossIcon stroke="#A7ACB0" />
        </div>
      </div>
      <div className="modal-body pt-0 find-groups-modal-body" style={{ padding: '1rem' }}>
        <SearchInput submit={handleSearchPeople} />

        <div className="overflow-auto max-vh-60">
          {searchResults.groups.length > 0 && (
            <GroupsSearchResults showHeading={true} data={groups} />
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchGroupsModal;
